import { render, staticRenderFns } from "./CompanyProfile6.vue?vue&type=template&id=30000186&scoped=true&"
import script from "./CompanyProfile6.vue?vue&type=script&lang=js&"
export * from "./CompanyProfile6.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfile6.vue?vue&type=style&index=0&id=30000186&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30000186",
  null
  
)

export default component.exports